import React, { useEffect, useRef } from 'react'
import Signature from './Signature'

/**
 * A small, perpetually-looping preview of a signature for the picker grid.
 * Reuses the real Signature engine on a slow loop so the grid is alive —
 * every tile hints at the world that detonates when you send it.
 */
export default function MiniSignature({ vibeKey, color }: { vibeKey: string; color: string }) {
  const [cycle, setCycle] = React.useState(0)
  useEffect(() => {
    // relaunch the animation every ~2.6s so tiles keep breathing
    const id = setInterval(() => setCycle((c) => c + 1), 2600)
    return () => clearInterval(id)
  }, [])
  return (
    <div style={{ position: 'absolute', inset: 0, borderRadius: 'inherit', overflow: 'hidden', opacity: 0.9 }}>
      <Signature key={cycle} vibeKey={vibeKey} color={color} duration={2400} intensity={1.0} fpsCap={20} />
    </div>
  )
}
